export default __webpack_public_path__ + "static/media/Group 61.811985e6.svg";